import React, { useState, useRef, useEffect, memo, useCallback, forwardRef } from "react";
import { Link, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { deleteingPost, setViewPost, updatePostCommentCount } from "../redux/post/postReducer";
import { useNavigate } from "react-router-dom";
import { likePost, unlikePost, savePost, unsavePost, deletePost } from "../redux/post/postAction";
import Profile from "../assests/defaultImage.png";
import DownIcon from "../assests/posts/down.png";
import moment from "moment";
import CommentIcon from "../assests/posts/comment.png";
import SendIcon from "../assests/posts/send.png";
import { AiOutlinePlus } from "react-icons/ai";
import { FaPaperPlane, FaShare, FaThumbsUp } from 'react-icons/fa';
import { MdCancel, MdEmojiEmotions } from "react-icons/md";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrashAlt, faBookmark, faTimes } from '@fortawesome/free-solid-svg-icons';
import Media from "./Media";
import ClickOutsideWrapper from "./ModalComponents/ClickOutsideWrapper";
import defaultAvatar from '../assests/defaultImage.png'
// import defaultThumbnail from "../assests/black-thumbnail.png"
import { motion } from "framer-motion";
import { toast } from "react-toastify";
import { CommentLoaders } from "./SkeletonLoaders";
import { createComment, deleteComment, editComment, getCommentReplies, getPostComments, replyComment } from "../redux/comment/commentAction";
import { CommentItem } from "./commentModal/comment-modal";
import { formatNumber } from "../helper";
import { useIntersectionAutoPlay } from "../hooks/useIntersectionAutoPlay";
import EmojiPicker from "emoji-picker-react";
import { toggleMute } from "../redux/user/userReducer";
import { isFileImage } from "../utils/isMage";
import LinkifiedText from "./LinkifiedText";
import DeleteModal from "./ModalComponents/DeletePost";
import defaultImage from "../assests/defaultImage.png";





export function PostUploadPreview({ upload }) {
  const { medias, caption, progress } = upload;
  const { url, type } = medias[0]

  return (
    <div className="p-2 bg-customGray shadow-black rounded-md shadow-sm animate-pulse">
      <div className="flex items-center">
        <div className="relative w-16 h-16 overflow-hidden rounded mr-4">
          <Media
            autoPlay={false}
            source={url}
            fileType={type}
            className="w-full h-full object-cover"
          />
          {medias.length > 1 && (
            <div className="absolute inset-0 bg-black opacity-50">
              <p className="text-white text-xs absolute bottom-1 left-1 font-bold ">+{medias.length - 1}</p>
            </div>
          )}
        </div>
        <div className="flex-1 flex flex-col">
          <p className="text-sm line-clamp-1 w-3/4">{caption || "New Post"}</p>
          <div className="w-full bg-customDark h-1 rounded mt-2">
            <div
              className="h-1 bg-customGold rounded"
              style={{ width: `${progress}%` }}
            />
          </div>
          <p className="text-xs text-gray-500 mt-1">{progress}% uploading...</p>
        </div>
      </div>
    </div>
  );
}

export const CommentInput = ({ profileImage, handlePostComment, handleReplyUser, replyComment, cancelReply, handleEditComment, className }) => {
  const [commentText, setCommentText] = useState('')
  const { user, comment, commentId, isEdit } = replyComment ?? {}
  const { firstName, lastName } = user ?? {}
  const inputRef = useRef(null)
  const [showEmojiPicker, setShowEmojiPicker] = useState({ state: false, position: null });



  useEffect(() => {
    if (replyComment) {
      inputRef.current?.focus()
      if (replyComment?.isEdit) {
        setCommentText(replyComment?.comment)
      }
    }
  }, [replyComment])

  const postComment = () => {
    if (!commentText.trim()) return
    setShowEmojiPicker({ state: false, position: null })
    if (replyComment) {
      if (isEdit) {
        handleEditComment({ commentId, comment: commentText })
        setCommentText('')
        return
      }
      handleReplyUser({ ...replyComment, comment: commentText })
      setCommentText('')
    } else {
      handlePostComment(commentText)
      setCommentText('')
    }
  }

  const handleEmojiSelect = (emoji) => {
    setCommentText((prev) => prev + emoji.emoji);
  }
  const toggleEmojiPicker = (e) => {
    if (showEmojiPicker.state) return setShowEmojiPicker({ state: false, position: null })
    e.stopPropagation();
    const clickY = e.clientY;
    const position = clickY > 350 ? 'top' : 'bottom';
    setShowEmojiPicker({ state: !showEmojiPicker.state, position });
  };

  return (
    <motion.div layout className={`${!className && "absolute bottom-0"} flex flex-col border-t border-black w-full text-xs font-outfit mt-2 z-30 pt-2 pb-1 bg-customGray backdrop-blur-sm shadow-sm ${className}`}>
      {replyComment &&
        <div className="flex px-4 text-white items-center  line-clamp-1 gap-2">
          {isEdit ?
            <>
              <span
                className="font-bold">Editing {`${comment?.length > 30 ? comment.substring(0, 30) : comment}`}...</span>
              <MdCancel
                onClick={() => {
                  cancelReply()
                  setCommentText("")
                }}
                className="cursor-pointer"
              />
            </>
            :
            <>
              <span className="font-bold">{firstName} {lastName}</span> <MdCancel onClick={cancelReply} className="cursor-pointer" />
            </>
          }
        </div>
      }

      <div className="overflow-hidden flex items-center w-full p-3 pt-4">
        <Link to="/profile" className="w-8 h-8 shrink-0">
          <img
            src={profileImage || defaultImage}
            alt="Profile"
            className="rounded-full"
          />        </Link>
        <div className="overflow-hidden flex bg-[#1C1B19] font-outfit text-sm rounded-full items-center ml-2 w-full">
          <div className={`absolute ${showEmojiPicker.position === 'top' ? 'bottom-10' : 'top-10'} left-0 z-10`}>
            <EmojiPicker open={showEmojiPicker.state} onEmojiClick={handleEmojiSelect} theme='dark' height={400} width={300} />
          </div>
          <button className="text-lg text-white p-2 hover:bg-gray-700 rounded-full ml-1" onClick={toggleEmojiPicker}>
            <MdEmojiEmotions />
          </button>
          <input
            ref={inputRef}
            type="text"
            placeholder={replyComment ? `Replying ${firstName} ${lastName}` : "Add a comment..."}
            className="outline-0 bg-[#1C1B19] p-1 pl-3 rounded-full w-full font-outfit"
            value={commentText}
            onChange={(e) => setCommentText(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                e.preventDefault();
                postComment()
              }
            }}
          />
          <button onClick={postComment}>
            <img src={SendIcon} alt="SendIcon" className="w-10" />
          </button>
        </div>
      </div>
    </motion.div>
  )
}

export const ViewPost = ({ feed, isPostPage, onClose }) => {
  const navigate = useNavigate()
  const location = useLocation();
  const dispatch = useDispatch()
  const mediaRef = useRef();
  const scrollRef = useRef()
  const { loading } = useSelector((state) => state.comment)
  useIntersectionAutoPlay(mediaRef)

  const { user, createdAt, postUrl, caption, postId, likesCount, commentCount, backgroundColour, postLiked, saved, scrollOffset } = feed
  const { profilePhoto, firstName, lastName, userId } = user
  const profileImage = profilePhoto && profilePhoto.length > 0 ? profilePhoto[0].photoPublicUrl : '';
  const [commentReply, setCommentReply] = useState(null)
  const [comments, setComments] = useState({
    page: 1,
    totalPage: 1,
    comments: []
  })
  const [repliesMap, setRepliesMap] = useState(new Map())

  const [isLike, setIsLike] = useState(postLiked)
  const [likeNum, setLikeNum] = useState(likesCount)
  const [commentTotal, setCommentTotal] = useState(commentCount)
  const [isOpen, setIsOpen] = useState(false);

  const { userData, profilePhotoUrl } = useSelector((state) => state.user)
  const myId = userData.userId

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  // const handleCopyLink = () => {
  // };

  // const handleShareIconClick = () => {
  //   handleCopyLink()
  //   toast.success('post link copied successfully!')
  // };

  const handleSavePost = async () => {
    try {
      setIsOpen(false)
      if (saved) {
        await dispatch(unsavePost(postId)).unwrap()
      } else {
        await dispatch(savePost({ postId, post: { ...feed, saved: true } })).unwrap()
      }
    }
    catch (error) {
      console.log('error saving post', error.message)
    }
  }
  const remainingImages = postUrl.length - 2;

  const handleLikePost = async () => {
    try {
      if (isLike) {
        setIsLike(false)
        if (likeNum > 0) {
          setLikeNum(num => num - 1)
        }
        await dispatch(unlikePost(postId)).unwrap()
      }
      else {
        setIsLike(true)
        setLikeNum(num => num + 1)
        await dispatch(likePost(postId)).unwrap()
      }
    }
    catch (error) {
      console.log('like failed ', error.message)
    }
  }

  const handleViewPost = (index) => {
    dispatch(setViewPost({ ...feed, viewPostIndex: index }))
    navigate(`/view-post/${postId}`, { preventScrollReset: true })
  }

  const navigateToUser = () => {
    if (userId === myId) {
      return '/Profile'
    } else {
      return `/user/${userId}`
    }
  }


  useEffect(() => {
    if (scrollRef.current && scrollOffset !== undefined) {
      scrollRef.current.scrollTop = scrollOffset;
    }
  }, [scrollOffset]);

  // Keep the originating feed card's comment count in sync: this modal
  // only tracks commentTotal locally, so push updates back into the shared
  // post lists whenever it changes (comment added/deleted).
  const isFirstCommentTotalRender = useRef(true)
  useEffect(() => {
    if (isFirstCommentTotalRender.current) {
      isFirstCommentTotalRender.current = false
      return
    }
    dispatch(updatePostCommentCount({ postId, commentCount: commentTotal }))
  }, [commentTotal, postId, dispatch]);


  //Comments and comment reply functionalities

  useEffect(() => {
    const fetchComments = async () => {
      try {
        const postComments = await dispatch(getPostComments({ postId, page: 1 })).unwrap()
        const commentsData = postComments.comments
        setComments(prev => ({ page: 1, comments: commentsData, totalPage: postComments.totalPages }))
      }
      catch (error) {
        toast.error(error.message)
        console.log('erro fetching post comment; ', error.message)
      }
    }

    if (postId) {
      fetchComments()
    }
  }, [dispatch, postId])

  // const loadMoreComment = async (page) => {
  //   try {
  //     const postComments = await dispatch(getPostComments({ postId, page: page || comments.page + 1 })).unwrap()
  //     const commentsData = postComments.comments
  //     setComments(prev => {
  //       const prevComments = prev.comments
  //       const existingIds = new Set(prevComments.map((c) => c.commentId))
  //       const newComments = commentsData?.filter((c) => !existingIds.has(c.commentId))

  //       return ({ ...prev, page: page, comments: [...prevComments, ...newComments] })
  //     })
  //   }
  //   catch (error) {
  //     toast.error(error.message)
  //   }
  // }

  const handlePostComment = useCallback(async (comment) => {
    const newComment = {
      commentId: `fake-comment-id-${Date.now()}-${Math.random()}`,
      user: {
        firstName: userData.firstName,
        lastName: userData.lastName,
        profilePhoto: userData.profilePhoto,
        userId: userData.userId,
        UserName: userData.UserName
      },
      userId: userData.userId,
      liked: false,
      text: comment,
      likesCount: 0,
      replyCount: 0,
      status: "pending",
      postId,
      createdAt: null
    }
    try {
      setComments(prev => ({ ...prev, comments: [newComment, ...prev.comments] }))

      const createdComment = await dispatch(createComment({ postId, comment: { text: newComment.text } })).unwrap()
      setComments((prevComments) => {
        const messageIndex = prevComments.comments.findIndex(
          (msg) => msg.commentId === newComment.commentId
        );

        if (messageIndex !== -1) {
          const updatedMessages = [...prevComments.comments];
          updatedMessages[messageIndex] = {
            ...newComment,
            status: "success",
            commentId: createdComment.commentId,
            createdAt: createdComment.createdAt
          }; // Update the message
          return { ...prevComments, comments: updatedMessages };
        }
        return prevComments; // Add new message
      });
      setCommentTotal(prev => prev + 1)

    }
    catch (error) {
      console.log('error pushing comment ', error.message)
      setComments((prevComments) => {
        const messageIndex = prevComments.comments.findIndex(
          (msg) => msg.commentId === newComment.commentId
        );

        if (messageIndex !== -1) {
          const updatedMessages = [...prevComments.comments];
          updatedMessages[messageIndex] = {
            ...newComment,
            status: "failed",
          }; // Update the message
          return { ...prevComments, comments: updatedMessages };
        }
        return prevComments; // Add new message
      });
    }
  }, [dispatch, postId, userData])

  const handleEditComment = useCallback(async (commentData) => {
    const { commentId, comment } = commentData ?? {}
    try {
      setComments((prevComments) => {
        const messageIndex = prevComments.comments.findIndex(
          (msg) => msg.commentId === commentId
        );

        if (messageIndex !== -1) {
          const updatedMessages = [...prevComments.comments];
          updatedMessages[messageIndex] = {
            ...updatedMessages[messageIndex],
            status: "editing",
            text: comment,
          }; // Optimistically update the message text
          return { ...prevComments, comments: updatedMessages };
        }
        return prevComments; // Add new message
      });

      const editedComment = await dispatch(editComment({ commentId, comment: { text: comment } })).unwrap()
      setComments((prevComments) => {
        const messageIndex = prevComments.comments.findIndex(
          (msg) => msg.commentId === commentId
        );

        if (messageIndex !== -1) {
          const updatedMessages = [...prevComments.comments];
          updatedMessages[messageIndex] = {
            ...updatedMessages[messageIndex],
            status: "success",
            text: editedComment.text ?? comment,
            commentId: editedComment.commentId ?? commentId,
            createdAt: editedComment.createdAt ?? updatedMessages[messageIndex].createdAt,
          }; // Update the message
          return { ...prevComments, comments: updatedMessages };
        }
        return prevComments; // Add new message
      });
      setCommentReply(null);

    } catch (error) {
      console.log('error editing comment ', error.message)
      setComments((prevComments) => {
        const messageIndex = prevComments.comments.findIndex(
          (msg) => msg.commentId === commentId
        );

        if (messageIndex !== -1) {
          const updatedMessages = [...prevComments.comments];
          updatedMessages[messageIndex] = {
            ...updatedMessages[messageIndex],
            status: "error",
          }; // Update the message
          return { ...prevComments, comments: updatedMessages };
        }
        return prevComments; // Add new message
      });
    }
  }, [dispatch])

  const handleRetryComment = useCallback(async (commentData) => {
    const { commentId, comment } = commentData ?? {}
    try {
      setComments((prevComments) => {
        const messageIndex = prevComments.comments.findIndex(
          (msg) => msg.commentId === commentId
        );

        if (messageIndex !== -1) {
          const updatedMessages = [...prevComments.comments];
          updatedMessages[messageIndex] = {
            ...updatedMessages[messageIndex],
            status: "pending",
          }; // Update the message
          return { ...prevComments, comments: updatedMessages };
        }
        return prevComments; // Add new message
      });

      const createdComment = await dispatch(createComment({ postId, comment: { text: comment } })).unwrap()
      setComments((prevComments) => {
        const messageIndex = prevComments.comments.findIndex(
          (msg) => msg.commentId === commentId
        );

        if (messageIndex !== -1) {
          const updatedMessages = [...prevComments.comments];
          updatedMessages[messageIndex] = {
            ...updatedMessages[messageIndex],
            status: "success",
            commentId: createdComment.commentId,
            createdAt: createdComment.createdAt
          }; // Update the message
          return { ...prevComments, comments: updatedMessages };
        }
        return prevComments; // Add new message
      });

    } catch (error) {
      console.log('error pushing comment ', error.message)
      setComments((prevComments) => {
        const messageIndex = prevComments.comments.findIndex(
          (msg) => msg.commentId === commentId
        );

        if (messageIndex !== -1) {
          const updatedMessages = [...prevComments.comments];
          updatedMessages[messageIndex] = {
            ...updatedMessages[messageIndex],
            status: "failed",
          }; // Update the message
          return { ...prevComments, comments: updatedMessages };
        }
        return prevComments; // Add new message
      });
    }
  }, [dispatch, postId])

  const fetchReplies = useCallback(async (commentId) => {
    console.log('comment id ; ', commentId)
    try {
      const replies = await dispatch(getCommentReplies(commentId)).unwrap()
      setRepliesMap(prev => {
        const newMap = new Map(prev);
        newMap.set(commentId, replies);
        return newMap;
      });
    }
    catch (error) {
      throw new Error(error.message)
    }
  }, [dispatch])

  const handleReplyComment = useCallback(async (replyData) => {
    setCommentReply(null)
    const { commentId, comment } = replyData ?? {}
    const user = {
      firstName: userData.firstName,
      lastName: userData.lastName,
      UserName: userData.UserName,
      userId: userData.userId,
      profilePhoto: userData.profilePhoto
    }
    const newRepy = {
      replyId: `fake-reply-id-${Date.now()}-${Math.random()}`,
      user: user,
      commentId: commentId,
      postId: postId,
      text: comment,
      status: "pending",
      likesCount: 0,
    }
    const commentPayload = {
      text: comment
    }

    try {
      setRepliesMap(prev => {
        const newMap = new Map(prev);
        const existing = newMap.get(commentId) || [];
        newMap.set(commentId, [...existing, newRepy]);
        return newMap;
      });

      const replied = await dispatch(replyComment({ postId, commentId, comment: commentPayload })).unwrap()

      setRepliesMap(prev => {
        const newMap = new Map(prev);
        const updated = (newMap.get(commentId) || []).map(c =>
          c.replyId === newRepy.replyId ? { ...c, replyId: replied.replyId, createdAt: replied.createdAt, status: 'success' } : c
        );
        newMap.set(commentId, updated);
        return newMap;
      });
    }
    catch (error) {
      setRepliesMap(prev => {
        const newMap = new Map(prev);
        const updated = (newMap.get(commentId) || []).map(c =>
          c.replyId === newRepy.replyId ? { ...c, status: "failed" } : c
        );
        newMap.set(commentId, updated);
        return newMap;
      });
    }
  }, [dispatch, postId, userData])

  const handleRetryReply = useCallback(async (replyData) => {
    const { commentId, replyId, comment } = replyData ?? {}

    setRepliesMap(prev => {
      const newMap = new Map(prev);
      const updated = (newMap.get(commentId) || []).map(c =>
        c.replyId === replyId ? { ...c, status: "pending" } : c
      );
      newMap.set(commentId, updated);
      return newMap;
    });

    const commentPayload = {
      text: comment
    }
    try {

      const replied = await dispatch(replyComment({ postId, commentId, comment: commentPayload })).unwrap()

      setRepliesMap(prev => {
        const newMap = new Map(prev);
        const updated = (newMap.get(commentId) || []).map(c =>
          c.replyId === replyId ? { ...c, replyId: replied.replyId, createdAt: replied.createdAt } : c
        );
        newMap.set(commentId, updated);
        return newMap;
      });
    }
    catch (error) {
      setRepliesMap(prev => {
        const newMap = new Map(prev);
        const updated = (newMap.get(commentId) || []).map(c =>
          c.replyId === replyId ? { ...c, status: "failed" } : c
        );
        newMap.set(commentId, updated);
        return newMap;
      });
    }

  }, [dispatch, postId])

  const handleDeleteComment = useCallback(async (commentId) => {
    try {
      const deletedComment = await dispatch(deleteComment(commentId)).unwrap()
      if (deletedComment === "Comment deleted successfully") {
        setComments((prevComments) => {
          const remainComment = prevComments.comments.filter((message) => message.commentId !== commentId)

          return { ...prevComments, comments: remainComment }
        });
        setCommentTotal(prev => Math.max(0, prev - 1))
      }
    } catch (error) {
      toast.error(error.message)

      throw new Error(error.message)
    }
  }, [dispatch])

  const handleSetCommentReply = useCallback((comment) => {
    setCommentReply(comment)
  }, [])

  const isProfilePage = location.pathname.includes("profile")
  const isUserProiflePage = location.pathname.includes("userProfile")


  return (
    <motion.div layoutRoot layoutId={isProfilePage ? `profile-${postId}` : isUserProiflePage ? `user-profile-${postId}` : postId} className="relative shadow-lg h-full w-full bg-[#353530] rounded-[1rem] overflow-hidden shadow-black" >
      <div ref={scrollRef} className={`text-white px-5 h-full py-4 ${!isPostPage ? `${commentCount <= 3 ? "pb-[200px]" : commentCount <= 5 ? "pb-[250px]" : 'pb-[400px]'}` : "pb-20"} w-full ${!isPostPage && "overflow-y-scroll scrollbar-hide"}`}>
        {/* Header */}
        <div className="flex items-center justify-between">
          <div className="flex items-center">
            <Link to={navigateToUser()} className="w-12 h-12 hover:opacity-90 hover:scale-105 transition duration-100 block">
              <img src={profileImage || Profile} alt="Profile" className="rounded-full" />
            </Link>
            <div className="ml-3 text-outfit">
              <Link to={navigateToUser()}>
                <p className="font-bold text-sm hover:opacity-80 hover:scale-105 transition duration-100">{firstName} {lastName}</p>
              </Link>
              <div className="flex">
                <p className="text-xs">{moment(createdAt).fromNow()}</p>
              </div>
            </div>
          </div>
          <div className="flex items-center gap-3">
            {onClose && (
              <button
                type="button"
                aria-label="Close and return to feed"
                onClick={onClose}
                className="text-white hover:opacity-80 hover:scale-105 transition duration-100"
              >
                <FontAwesomeIcon icon={faTimes} />
              </button>
            )}
            <div className="relative inline-block text-left">
              <div>
                <img
                  src={DownIcon}
                  alt="DownIcon"
                  className="downn-click w-3 hover:opacity-80 hover:scale-105 transition duration-100 cursor-pointer"
                  onClick={toggleDropdown}
                />
              </div>

              {isOpen && (
                <ClickOutsideWrapper ignoreSelector={'downn-click'} onClose={() => setIsOpen(false)} className="absolute right-0 mt-2 w-48 rounded-md shadow-lg bg-[#101010] ring-1 ring-black ring-opacity-5 focus:outline-none z-10">
                  <div className="py-1">
                    <button
                      className="flex items-center gap-2 w-full px-4 py-2 text-white hover:bg-gray-7"
                      onClick={handleSavePost}
                    >
                      <FontAwesomeIcon icon={saved ? faTimes : faBookmark} className="mr-2" />
                      {saved ? 'Unsave post' : 'Save post'}
                    </button>
                    {/* {userId === myId &&
                      <button
                        className="flex items-center gap-2 w-full px-4 py-2 text-white hover:bg-gray-700"
                      >
                        <FontAwesomeIcon icon={faTrashAlt} className="mr-2" />
                        Delete post
                      </button>
                    } */}
                  </div>
                </ClickOutsideWrapper>
              )}
            </div>
          </div>
        </div>
        {/* Image */}
        {postUrl.length > 0 ? (
          <div className="grid grid-cols-2 w-full gap-2 mt-2">
            {postUrl.slice(0, 2).map((image, index) => (
              <div
                key={index}
                className={`relative ${postUrl.length === 1 ? "col-span-2" : ""}`}
                style={{ maxHeight: postUrl.length === 1 ? "500px" : "300px" }} // Set a maximum height for the container
              >
                <div onClick={() => handleViewPost(index)} className="w-full h-full">
                  <Media
                    ref={mediaRef}
                    autoPlay={false}
                    fileType={image.fileType}
                    controls={true}
                    source={image.postUrl}
                    alt={`Post ${index + 1}`}
                    vidObjectFit={"cover"}
                    className="w-full h-full object-cover  bg-black rounded" // Ensure media fills the container
                    isPost
                  />
                </div>
                {index === 1 && postUrl.length > 2 && (
                  <>
                    <div className="absolute inset-0 bg-black opacity-70 rounded"></div>
                    <button
                      onClick={() => handleViewPost(index)}
                      className="absolute inset-0 flex justify-center items-center"
                    >
                      <AiOutlinePlus className="text-white text-2xl cursor-pointer" />
                      <span className="absolute top-1/2 left-1/2 mx-4 transform -translate-x-1/2 -translate-y-1/2 text-xl font-light">
                        {remainingImages}
                      </span>
                    </button>
                  </>
                )}
              </div>
            ))}
            <div className="col-span-2">
              <LinkifiedText text={caption} className="overflow-hidden overflow-ellipsis" />
            </div>
          </div>

        ) : (
          <div className="w-full mt-4">
            <p
              className="w-full block text-center"
              style={{
                backgroundColor: backgroundColour,
                height: "320px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                padding: "0.8rem",
                fontFamily: "Outfit",
                textAlign: "center",
                lineHeight: "1.5",
                letterSpacing: "0.5px",
                textShadow: "2px 2px 4px rgba(0, 0, 0, 0.5)"
              }}
            >
              {caption}
            </p>
          </div>
        )
        }
        {/* Number of Likes + Buttons */}
        <div>
          <div className="items-center text-[#8e8d8d font-outfit]">
            <div className="flex items-center py-2 justify-between">
              <div className="flex items-center gap-2">
                <button className="w-[1.1rem] h-[1.1rem]">

                  <FaThumbsUp
                    className={`hover:opacity-80 hover:scale-105 transition duration-100 ${isLike ? 'text-yellow-500' : 'text-white'}`}
                    onClick={handleLikePost}
                  />

                </button>
                <p className="text-xs font-outfit">{likeNum} likes</p>
                <div
                  className="w-[1.1rem] h-[1.1rem]"
                >
                  <img
                    src={CommentIcon}
                    alt="CommentIcon"
                    className="hover:opacity-80 hover:scale-105 transition duration-100"
                  />
                </div>
                <p className="text-xs font-outfit">{commentTotal} comments</p>
              </div>
              <div>
                {/* <div className="w-[1.1rem] h-[1.1rem]" onClick={handleShareIconClick}>
                  <FaShare
                    className="hover:opacity-80 hover:scale-105 transition duration-100"
                  />
                </div> */}

              </div>
            </div>
          </div>


        </div>

        { /*Post comments*/}
        <div className="py-2 w-full flex flex-col min-h-20 justify-center items-center mt-2">

          {comments?.comments?.length > 0 &&
            comments.comments.map((comment) => (
              <CommentItem
                key={comment.commentId}
                comment={comment}
                loadReplies={fetchReplies}
                handleDelete={handleDeleteComment}
                replies={repliesMap.get(comment.commentId) || []}
                reply={handleSetCommentReply}
                retryComment={handleRetryComment}
                retryReply={handleRetryReply}
                isEditing={commentReply?.isEdit && commentReply.commentId === comment.commentId}
                myId={myId}
              />
            ))
          }

          {loading &&
            <>
              <CommentLoaders />
              {commentCount >= 2 && <CommentLoaders />}
              {commentCount >= 3 && <CommentLoaders />}
              {commentCount >= 4 && <CommentLoaders />}
              {commentCount >= 5 && <CommentLoaders />}
            </>
          }

          {comments.comments.length === 0 && !loading && <p className="text-white">There's no comments on this post</p>}
          {/* <CommentLoaders />
          <CommentLoaders /> */}
        </div>
      </div>

      {isPostPage && <div className="fixed bottom-0 h-5 bg-[#1C1B16] w-full lg:w-1/2 max-w-[768px]" />}

      <CommentInput
        className={isPostPage && "fixed bottom-0 w-full lg:w-1/2 max-w-[calc(100%-8px)] sm:max-w-[720px] lg:max-w-[768px] rounded-b-[1rem]"}
        profileImage={profilePhotoUrl}
        cancelReply={() => setCommentReply(null)}
        handlePostComment={handlePostComment}
        handleReplyUser={handleReplyComment}
        handleEditComment={handleEditComment}
        replyComment={commentReply}
      />

    </motion.div>

  );
};

const PostInput = forwardRef(({ postId, callback }, ref) => {
  const dispatch = useDispatch();
  const { profilePhotoUrl } = useSelector((state) => state.user);
  const [loading, setLoading] = useState(false);
  const [commentText, setCommentText] = useState("");
  const [showEmojiPicker, setShowEmojiPicker] = useState(false);
  const emojiButtonRef = useRef(null);
  const emojiPickerRef = useRef(null);
  const inputRef = useRef(null);

  // Click outside handler – closes emoji picker when clicking outside button or picker
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (
        emojiPickerRef.current &&
        !emojiPickerRef.current.contains(e.target) &&
        emojiButtonRef.current &&
        !emojiButtonRef.current.contains(e.target)
      ) {
        setShowEmojiPicker(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleCommentSubmit = async () => {
    if (!commentText.trim()) return;
    setLoading(true);
    setShowEmojiPicker(false); // ✅ fixed: was incorrectly using object
    try {
      await dispatch(createComment({ postId, comment: { text: commentText.trim() } })).unwrap();
      setCommentText("");
      callback();
      toast.success("Comment sent successfully!");
    } catch (error) {
      toast.error(error.message);
    } finally {
      setLoading(false);
    }
  };

  const handleEmojiClick = (emojiData) => {
    setCommentText((prev) => prev + emojiData.emoji);
    inputRef.current.focus();
  };

  return (
    <div className={`flex items-center w-full p-3 pt-4 px-0 ${loading ? "opacity-60" : ""}`}>
      <Link to="/profile" className="w-8 h-8 shrink-0">
        <img src={profilePhotoUrl || defaultAvatar} alt="Profile" className="rounded-full" />
      </Link>
      <div className="flex bg-[#1C1B19] font-outfit text-sm rounded-full items-center ml-2 w-full relative">
        <button
          ref={emojiButtonRef}
          onClick={() => setShowEmojiPicker((prev) => !prev)}
          className="bg-customDark px-2 py-1 sm:px-3 sm:py-2 rounded text-sm sm:text-base"
        >
          😊
        </button>

        {showEmojiPicker && (
          <div ref={emojiPickerRef} className="absolute bottom-16 ">
            <EmojiPicker theme="dark" onEmojiClick={handleEmojiClick} />
          </div>
        )}

        <input
          id={`comment-${postId}`}
          ref={inputRef}
          type="text"
          disabled={loading}
          placeholder="Add a comment..."
          className="outline-0 bg-[#1C1B19] p-1 rounded-full w-full font-outfit"
          value={commentText}
          onChange={(e) => setCommentText(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === "Enter" && !loading) {
              e.preventDefault();
              handleCommentSubmit();
            }
          }}
        />

        <button
          disabled={loading || !commentText.trim()}
          className="flex items-center bg-white text-customDark p-3 text-sm rounded-full"
          onClick={handleCommentSubmit}
        >
          {!loading && <FaPaperPlane />}
          {loading && <div className="w-3 h-3 border-4 border-white border-l-customDark border-t-customDark rounded-full animate-spin" />}
        </button>
      </div>
    </div>
  );
});


const Post = ({ feed, viewPost }) => {
  const navigate = useNavigate()
  const location = useLocation();
  const dispatch = useDispatch()
  const mediaRef = useRef();
  const inputRef = useRef(null)
  const postItemRef = useRef()
  const { user, createdAt, postUrl, caption, postId, likesCount, commentCount, backgroundColour, postLiked, saved } = feed
  const { profilePhoto, firstName, lastName, userId } = user ?? {}
  const profileImage = profilePhoto && profilePhoto.length > 0 ? profilePhoto[0].photoPublicUrl : '';
  const [isDelete, setIsDelete] = useState(false);
  const [isLike, setIsLike] = useState(postLiked)
  const [likeNum, setLikeNum] = useState(likesCount)
  const [commentNum, setCommentNum] = useState(commentCount);
  const { userData, muted } = useSelector((state) => state.user)
  const { deleting } = useSelector((state) => state.post)
  const myId = userData.userId
  const [isOpen, setIsOpen] = useState(false);
  const isDeletingThisPost = deleting?.find((post) => post === postId)
  useIntersectionAutoPlay(mediaRef)

  // The comment modal (ViewPost) updates commentCount in the redux post
  // lists when a comment is added/deleted; since this card's commentNum is
  // its own local state (key={postId} keeps it mounted across re-renders),
  // it needs to be re-synced whenever the underlying commentCount changes.
  useEffect(() => {
    setCommentNum(commentCount);
  }, [commentCount]);

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  const handleSavePost = async () => {
    try {
      setIsOpen(false);

      if (saved) {
        await dispatch(unsavePost(postId)).unwrap();
      } else {
        const timeStamp = new Date().toISOString();

        await dispatch(
          savePost({
            postId,
            post: {
              ...feed,
              saved: true,
              savedAt: timeStamp,
            },
          })
        ).unwrap();
      }

    } catch (error) {
      console.log("error saving post", error.message);
    }
  };


  const handleCopyLink = async (postLink) => {
    await navigator.clipboard.writeText(postLink)
    toast.success('Post link copied to clipboard!')
  };
  const handleShareIconClick = async () => {
    const postLink = `${window.location.origin}/post/${postId}`
    try {
      if (navigator.share) {
        await navigator.share({ title: `${firstName} ${lastName} on BD`, text: caption, url: postLink })
        return
      }
      await handleCopyLink(postLink)
    } catch (error) {
      // AbortError happens when the user cancels the native share sheet, ignore it
      if (error?.name === 'AbortError') return
      try {
        await handleCopyLink(postLink)
      } catch (copyError) {
        toast.error('Unable to share post')
      }
    }
  };

  // const selectedImages = [Image1, Image2, Image3, Image4, Image5];

  const remainingImages = postUrl.length - 2;

  const handleLikePost = async () => {
    try {
      if (isLike) {
        setIsLike(false)
        if (likeNum > 0) {
          setLikeNum(num => num - 1)
        }
        await dispatch(unlikePost(postId)).unwrap()
      }
      else {
        setIsLike(true)
        setLikeNum(num => num + 1)
        await dispatch(likePost(postId)).unwrap()
      }
    }
    catch (error) {
      console.log('like failed ', error.message)
    }
  }

  const handleViewPost = (index) => {
    dispatch(setViewPost({ ...feed, viewPostIndex: index }))
    navigate(`/view-post/${postId}`, { preventScrollReset: true })
  }

  const navigateToUser = () => {
    if (userId === myId) {
      return '/Profile'
    } else {
      return `/user/${userId}`
    }
  }

  const handleViewComment = () => {
    if (postItemRef.current) {
      const rect = postItemRef.current.getBoundingClientRect();
      const scrollOffset = rect.top;
      viewPost({ ...feed, scrollOffset: -scrollOffset })
    }

  }

  const [isExpanded, setIsExpanded] = useState(false);
  const isProfilePage = location.pathname.includes("/profile")
  const isUserProiflePage = location.pathname.includes("userProfile")

  const handleDeletePost = () => {
    setIsDelete(false)
    dispatch(deleteingPost({ postId }))
    dispatch(deletePost({ postId, userId: myId }))
  }

  const handlePostClick = (index, type) => {
    if (muted && !isFileImage(type)) {
      return dispatch(toggleMute(false))
    }
    handleViewPost(index)
  }

  const renderTextWithLineBreaks = (text) => {
    if (!text) return null;
    // Handle both \r\n and \n line breaks
    const lines = text.split(/\r?\n/);
    return lines.map((line, index, array) => (
      <React.Fragment key={index}>
        <LinkifiedText text={line} />
        {index < array.length - 1 && <br />}
      </React.Fragment>
    ));
  };

  // console.log('post mute status; ', muted)

  return (
    <motion.div
      ref={postItemRef}
      layoutId={isProfilePage ? `profile-${postId}` : isUserProiflePage ? `user-profile-${postId}` : postId}
      className="text-white bg-[#353530] shadow shadow-black/80 rounded-xl md:rounded-[22px] py-2 w-full"
      style={{ opacity: isDeletingThisPost ? 0.5 : 1, pointerEvents: isDeletingThisPost ? 'none' : 'auto' }}
    >
      {/* Header */}
      <div className="flex items-center justify-between px-3">
        <div className="flex items-center">
          <Link to={navigateToUser()} className="w-12 h-12 hover:opacity-90 hover:scale-105 transition duration-100 block">
            <img src={profileImage || Profile} alt="Profile" className="rounded-full" />
          </Link>
          <div className="ml-3 text-outfit">
            <Link to={navigateToUser()}>
              <p className="font-bold text-sm hover:opacity-80 hover:scale-105 transition duration-100">{firstName} {lastName}</p>
            </Link>
            <div className="flex">
              <p className="text-xs">
                {moment(createdAt).fromNow()}
              </p>

            </div>
          </div>
        </div>
        {userId === myId && (
          <div className="relative inline-block text-left">
            <div>
              <img
                src={DownIcon}
                alt="DownIcon"
                className="down-click w-3 hover:opacity-80 hover:scale-105 transition duration-100 cursor-pointer"
                onClick={toggleDropdown}
              />
            </div>

            {isDelete &&
              <DeleteModal
                closeModal={() => setIsDelete(false)}
                deletePost={handleDeletePost}
              />}

            {isOpen && (
              <ClickOutsideWrapper ignoreSelector={'down-click'} onClose={() => setIsOpen(false)} className="absolute right-0 mt-2 w-48 rounded-md shadow-lg bg-[#101010] ring-1 ring-black ring-opacity-5 focus:outline-none z-10">
                <div className="py-1">
                  <button
                    className="flex items-center gap-2 w-full px-4 py-2 text-white hover:bg-gray-700"
                    onClick={() => {
                      setIsOpen(false)
                      setIsDelete(true)
                    }}
                  >
                    <FontAwesomeIcon icon={faTrashAlt} className="mr-2" />
                    Delete post
                  </button>
                </div>
              </ClickOutsideWrapper>
            )}
          </div>
        )}
      </div>

      {/* Image */}
      {postUrl.length > 0 ? (
        <div className="grid grid-cols-2 gap-0.5 mt-2 md:px-3">
          {postUrl.slice(0, 2).map((image, index) => (
            <div
              key={index}
              className={`relative md:rounded overflow-hidden ${postUrl.length === 1 ? "col-span-2" : ""}`}
              style={{ maxHeight: postUrl.length === 1 ? "500px" : "300px" }}
            >
              <div onClick={() => handlePostClick(index, image.fileType)} className="w-full h-full bg-gray-500">
                <Media
                  ref={mediaRef}
                  autoPlay={false}
                  fileType={image.fileType}
                  controls
                  source={image.postUrl}
                  alt={`Post ${index + 1}`}
                  vidObjectFit={"cover"}
                  className={`w-full h-full ${postUrl.length === 1 ? "object-contain" : "object-cover"} bg-black min-h-64`}
                  thumbnailUrl={image.thumbnailUrl}
                  muted={muted}
                  duration={image.duration}
                  isPost
                  handleFullscreen={() => handleViewPost(index)}
                />
              </div>
              {index === 1 && postUrl.length > 2 && (
                <>
                  <div className="absolute inset-0 bg-black opacity-70 rounded"></div>
                  <button
                    onClick={() => handleViewPost(index)}
                    className="absolute inset-0 flex justify-center items-center"
                  >
                    <AiOutlinePlus className="text-white text-2xl cursor-pointer" />
                    <span className="absolute top-1/2 left-1/2 mx-4 transform -translate-x-1/2 -translate-y-1/2 text-xl font-light">
                      {remainingImages}
                    </span>
                  </button>
                </>
              )}
            </div>
          ))}
          <div className="col-span-2 px-3 md:px-0">
            {caption.length > 50 ? (
              <div className="overflow-hidden overflow-ellipsis">
                {isExpanded
                  ? renderTextWithLineBreaks(caption)
                  : renderTextWithLineBreaks(`${caption.substring(0, 50)}...`)}
                <span
                  onClick={() => setIsExpanded(!isExpanded)}
                  className="text-bold text-customGold px-4 hover:underline cursor-pointer"
                >
                  {isExpanded ? " See less" : " See more"}
                </span>
              </div>
            ) : (
              <div>
                {renderTextWithLineBreaks(caption)}
              </div>
            )}
          </div>
        </div>
      ) : (
        <div className="w-full mt-4">
          <div
            className="w-full block text-center"
            style={{
              backgroundColor: backgroundColour,
              height: "320px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              padding: "0.8rem",
              fontFamily: "Outfit",
              textAlign: "center",
              lineHeight: "1.5",
              letterSpacing: "0.5px",
              textShadow: "2px 2px 4px rgba(0, 0, 0, 0.5)",
              flexDirection: "column",
              overflow: "auto"
            }}
          >
            {renderTextWithLineBreaks(caption)}
          </div>
        </div>
      )}
      {/* Number of Likes + Buttons */}
      <div className="px-3 md:px-5">
        <div className="items-center text-[#8e8d8d font-outfit]">
          <div className="flex items-center py-2 justify-between">
            <div className="flex items-center gap-2">
              <button className="w-[1.1rem] h-[1.1rem]">

                <FaThumbsUp
                  className={`hover:opacity-80 hover:scale-105 transition duration-100 ${isLike ? 'text-customGold' : 'text-white'}`}
                  onClick={handleLikePost}
                />

              </button>
              <p className="text-xs font-outfit">{likeNum} likes</p>
              <button
                className="w-[1.1rem] h-[1.1rem]"
                onClick={commentNum > 0 ? handleViewComment : () => inputRef.current?.focus()}
              >
                <img
                  src={CommentIcon}
                  alt="CommentIcon"
                  className="hover:opacity-80 hover:scale-105 transition duration-100"
                />
              </button>

              <p className="text-xs font-outfit">{formatNumber(commentNum)} comments</p>
            </div>
            <div className="flex items-center gap-3">
              <button className="w-[1.1rem] h-[1.1rem]" onClick={handleSavePost}>
                <FontAwesomeIcon
                  icon={saved ? faTimes : faBookmark}
                  className={`hover:opacity-80 hover:scale-105 transition duration-100 ${saved ? 'text-customGold' : 'text-white'}`}
                />
              </button>
              <button className="w-[1.1rem] h-[1.1rem]" >
                <FaShare onClick={handleShareIconClick}
                  className="hover:opacity-80 hover:scale-105 transition duration-100"
                />
              </button>
            </div>
          </div>
        </div>
        {/* Comments */}
        <div className="text-xs font-outfit mt-1">
          {/* {comments.map((comment, index) => (
            <CommentItem key={index} index={index} comment={comment} />
          ))} */}
          {/* Show more comments button */}
          {/* {comments.length > 5 && !showAllComments && (
            <div className="text-sm cursor-pointer text-gray-500" onClick={handleShowMoreComments}>
              Show more
            </div>
          )} */}
          {/* Comment Input */}
          <PostInput ref={inputRef} postId={postId} callback={() => setCommentNum(prev => prev + 1)} />
        </div>
      </div>
    </motion.div>

  );
};

export default memo(Post);
